<button class="hint-chip__chip d-inline-flex align-items-center gap-1 mat-font-body-sm"
        [title]="data().label" [matMenuTriggerFor]="menu">
  <mat-icon class="mat-icon-sm mat-text-primary">map</mat-icon>
  <span class="hint-chip__label">{{ label }}</span>
  <mat-icon class="mat-icon-sm mat-text-on-surface-variant">arrow_drop_down</mat-icon>
</button>

<mat-menu #menu="matMenu">
  @if (bbox()) {
    <button mat-menu-item (click)="zoomTo()">
      <mat-icon>zoom_out_map</mat-icon><span>Zoom to</span>
    </button>
  }
  <button mat-menu-item (click)="view()" [disabled]="viewing()">
    <mat-icon>data_object</mat-icon>
    <span>{{ viewing() ? 'Loading…' : 'View data' }}</span>
  </button>
  <button mat-menu-item (click)="addToMap()" [disabled]="adding()">
    <mat-icon>layers</mat-icon>
    <span>{{ adding() ? 'Adding…' : 'Add to map' }}</span>
  </button>
</mat-menu>
